import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { LayoutListItemProps } from './LayoutList.types';
import { ChevronRight } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';

export const LayoutListItem: React.FC<{
  item: LayoutListItemProps;
  onItemClicked: (item: LayoutListItemProps) => void;
}> = ({ item, onItemClicked }) => {
  const Icon = item.icon;
  return (
    <Flex
      _hover={{
        backgroundColor: 'mono2',
        transition: 'all',
      }}
      _active={{
        backgroundColor: 'mono3',
        transition: 'all',
      }}
      paddingX={16}
      justifyContent={'space-between'}
      cursor={'pointer'}
      paddingY={7}
      borderBottom={'1px solid'}
      borderColor={'mono3'}
      width={'100%'}
      alignItems={'center'}
      gap={16}
      onClick={() => onItemClicked(item)}
      role="group"
    >
      <Icon
        size={32}
        color={'mono14'}
        _groupHover={{ color: 'linkHover' }}
        _groupActive={{ color: 'linkActive' }}
      />
      <Flex flexDirection={'column'}>
        <TextV2
          typographyVariant={'button2'}
          _groupHover={{ color: 'linkHover' }}
          _groupActive={{ color: 'linkActive' }}
        >
          {item.title}
        </TextV2>
        <TextV2
          typographyVariant={'body1'}
          _groupHover={{ color: 'linkHover' }}
          _groupActive={{ color: 'linkActive' }}
          marginTop={pxToRem(4)}
        >
          {item.subtitle}
        </TextV2>
      </Flex>
      <ChevronRight />
    </Flex>
  );
};
